export default {
  baseStyle: {
    color: 'gray.200',
    fontSize: 'sm',
    textTransform: 'uppercase',
    margin: '0',
  },
};
